import React, { useRef, useEffect } from "react";
import { ArrowRight } from "lucide-react"; // icon

const Projects = () => {
  const sectionRef = useRef();

  useEffect(() => {
    const section = sectionRef.current;
    const onScroll = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add("visible");
        }
      });
    };
    const observer = new window.IntersectionObserver(onScroll, { threshold: 0.2 });
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  const projectData = [
    {
      category: "Interior Design",
      title: "Ikoyi Luxury Residence",
      desc: "Stunning POP ceiling designs with integrated LED lighting throughout the residence, creating an atmosphere of luxury and sophistication.",
      keyResult: "15 rooms redesigned",
      testimonial: "The POP ceiling designs are absolutely stunning. Exceeded all expectations!",
      client: "Empire Homes Nigeria",
      before: "/assets/images/B1.JPG",
      after: "/assets/images/b2.JPG",
    },
    {
      category: "Corporate Office",
      title: "Victoria Island HQ Renovation",
      desc: "Complete office transformation with modern layouts, ergonomic furniture, and high-end finishes that reflect corporate identity.",
      keyResult: "98% client satisfaction",
      testimonial: "Zirae transformed our office completely. The quality and attention to detail is exceptional.",
      client: "PropertyMart Development Ltd.",
      before: "/assets/images/cotton.webp",
      after: "/assets/images/cotton.webp",
    },
    {
      category: "Residential Apartment",
      title: "Lekki Waterfront Apartments",
      desc: "Luxury textures, premium coatings, and stylish POP ceiling installations to elevate modern living experiences.",
      keyResult: "95% repeat client referrals",
      testimonial: "Our apartment feels brand new. The team exceeded our expectations in every detail.",
      client: "Emerald Homes Ltd.",
      before: "/assets/images/cotton.webp",
      after: "/assets/images/cotton.webp",
    },
  ];

  return (
    <section id="projects" ref={sectionRef} className="projects-animate">
      <h2 className="projects-title">OUR PROJECTS</h2>

      {projectData.map((proj, index) => (
        <div className="project-block" key={index}>
          {/* Before / After */}
          <div className="before-after">
            <div className="before">
              <img src={proj.before} alt="Before" />
              <span className="label before-label">Before</span>
            </div>
            <div className="arrow-circle">
              <ArrowRight size={20} />
            </div>
            <div className="after">
              <img src={proj.after} alt="After" />
              <span className="label after-label">After</span>
            </div>
          </div>

          {/* Project Info */}
          <div className="project-info">
            <span className="category">{proj.category}</span>
            <h3 className="project-title">{proj.title}</h3>
            <p className="project-desc">{proj.desc}</p>

            <div className="key-result">
              📈 Key Result: <strong>{proj.keyResult}</strong>
            </div>

            <blockquote className="testimonia">
              <p>“{proj.testimonial}”</p>
              <cite>— {proj.client}</cite>
            </blockquote>

            <button className="cta-btn">Start Similar Project</button>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Projects;
